import React, { useEffect, useState } from 'react';
import { Col, Row, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import UpdateIcon from '@material-ui/icons/Update';
import { makeStyles } from "@material-ui/core/styles";
import GetAppIcon from '@material-ui/icons/GetApp';
import moment from 'moment';
import CurrencyFormat from '../../Helpers/Formatters/CurrencyFormat';
import CustomerSupportPhone from '../../Account/CustomerSupportPhone';

export default function ApplicationStatus(props) {

  const [activeStep, setActiveStep] = useState(1);
  const [activeText, setActiveText] = useState([]);
  const [step3Title, setStep3Title] = useState("Application Decision");

  const weCanHelpYouText = <div>We can help you find the right insurance coverage at the right price. Based on the information you provided in your previous application, we would love to show you the options you’re most likely eligible for. <a href="/quote/term-life-insurance/multi-carrier-term">Click Here</a> to see other products from our partners.</div>;

  const phoneNumber = CustomerSupportPhone();

  useEffect(() => {

    var personalizeExperienceText = <div>For an even more personalized experience, contact our team of insurance experts at {phoneNumber}.</div >;

    switch (props.statusId) {
      case CaseStatus.Disability_Pending_AwaitingSignatures:
      case CaseStatus.Health_Pending_AwaitingSignatures:
      case CaseStatus.Life_Pending_AwaitingSignatures:
      case CaseStatus.Disability_Pending_PendingSubmission:
      case CaseStatus.Health_Pending_PendingSubmission:
      case CaseStatus.Life_Pending_PendingSubmission:
        setActiveStep(1);
        setActiveText([
          "Your policy application is being reviewed and a decision will be returned shortly. You will receive an email when a decision is returned - usually within 5 minutes.",
          <SendStatusEmailButton onResendEmailButtonClicked={props.sendStatusEmail} />,
        ]);
        break;

      case CaseStatus.Disability_Pending_AppSubmitted:
      case CaseStatus.Health_Pending_AppSubmitted:
      case CaseStatus.Life_Pending_AppSubmitted:
      case CaseStatus.Life_Pending_PendingDecision:
        setActiveStep(2);
        setActiveText(["Your policy application is being reviewed. You should receive a notification within 2 days."]);
        break;

      case CaseStatus.Disability_Closed_NotTaken:
      case CaseStatus.Health_Closed_NotTaken:
      case CaseStatus.Life_Closed_NotTaken:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry you declined this offer</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, you declined the offer for this product, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Declined")
        break;

      case CaseStatus.Disability_Closed_Declined:
      case CaseStatus.Health_Closed_Declined:
      case CaseStatus.Life_Closed_Declined:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry – you’re not eligible for this product</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, you (or the proposed insured) are not eligible for this product, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Declined")
        break;

      case CaseStatus.Disability_Pending_Approved:
      case CaseStatus.Life_Pending_Approved:
      case CaseStatus.Disability_Pending_AwaitingPremiumDraft:
      case CaseStatus.Health_Pending_AwaitingPremiumDraft:
      case CaseStatus.Life_Pending_AwaitingPremiumDraft:
      case CaseStatus.Life_Pending_IssuedDelReq:
      case CaseStatus.Disability_Pending_ApprovedOther:
      case CaseStatus.Life_Pending_ApprovedOther:
      case 159: //policy sent
      case CaseStatus.Disability_Paid_InForce:
      case CaseStatus.Health_Paid_InForce:
      case CaseStatus.Life_Paid_InForce:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>Congratulations your application has been approved!</span>,
          `${`Policy Number: ${(props.policyNumber === null || props.policyNumber === '') ? 'Pending' : props.policyNumber}`}`,
          `Policy Effective Date: ${moment(props.policyDate).format('M/D/YYYY')}`,
          `Your first premium withdrawal will occur on ${moment(props.policyDate).format('M/D/YYYY')} and will occur on the ${ordinal(moment(props.policyDate).format('D'))} of the month each month thereafter.`,
          <span className='stepTextHeader'>Policy Insurance-What happens next?</span>,
          "Within 7-10 days you will receive a welcome package that includes your insurance documents. ",
          <span className='stepTextHeader'>Questions about your policy</span>,
          "For questions regarding your policy, from underwriting decisions to policy delivery, we are here to help. Chat with an expert, email, or call.",
        ]);
        setStep3Title("Approved");
        break;

      case CaseStatus.Disability_Closed_Cancelled:
      case CaseStatus.Health_Closed_Cancelled:
      case CaseStatus.Life_Closed_Cancelled:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry this offer is cancelled</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, the application was cancelled, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Cancelled");
        break;

      case CaseStatus.Disability_Closed_IncompleteClosed:
      case CaseStatus.Health_Closed_IncompleteClosed:
      case CaseStatus.Life_Closed_IncompleteClosed:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry this offer is closed</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, the application was closed, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Closed");
        break;

      case CaseStatus.Disability_Paid_Lapsed:
      case CaseStatus.Health_Paid_Lapsed:
      case CaseStatus.Life_Paid_Lapsed:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry your policy has lapsed</span>,
          `Unfortunately, your ${props.productName} policy has lapsed - this can happen for any number of reasons. But don’t worry, you may still have options. `,
          `Please contact our team of insurance experts at ${phoneNumber}.`
        ]);
        setStep3Title("Lapsed");
        break;

      case CaseStatus.Health_Closed_Postponed:
      case CaseStatus.Life_Closed_Postponed:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry your application has been postponed</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, the application was postponed, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Postponed");
        break;

      case CaseStatus.Disability_Closed_Withdrawn:
      case CaseStatus.Health_Closed_Withdrawn:
      case CaseStatus.Life_Closed_Withdrawn:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry your application has been withdrawn</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, the application was withdrawn, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Withdrawn");
        break;

      default:
        setActiveStep(3);
        setActiveText([
          <span className='stepTextHeader'>We’re sorry, something has gone wrong</span>,
          `Thank you for your interest in ${props.productName}. Unfortunately, something has gone wrong, but don’t worry - this can happen for any number of reasons and doesn’t mean you can’t find other suitable options.`,
          weCanHelpYouText,
          personalizeExperienceText
        ]);
        setStep3Title("Please Contact Support");
    }
  }, []);

  return (
    <Container className="status">
      <Row>
        <Col lg={8}>
          <p className="statusTitle">Nice job - now it's our turn</p>

          <p className="statusSubTitle">You’ve completed your application. <br />There’s just three more steps on our end.</p>

          <p className="statusNext">Next Steps</p>

          <StatusSection
            time="5 minutes"
            stepNumber="1"
            stepName="Automated Review"
            stepText={activeText}
            active={activeStep === 1}
          />

          <StatusSection
            time="48 hours"
            stepNumber="2"
            stepName="Manual Review"
            stepText={activeText}
            active={activeStep === 2}
          />

          <StatusSection
            time="Approved/Declined"
            showTimeIcon={false}
            stepNumber="3"
            stepName={step3Title}
            stepText={activeText}
            active={activeStep === 3}
          />

        </Col>
        <Col lg={4}>
          <div className="applicationSummary">

            <p className="appSummaryTitle">Application Summary</p>

            <p className="appSummaryInfoTitle">Insured</p>
            <p className="appSummaryInfoText">{props.insuredName}</p>


            <p className="appSummaryInfoTitle">Coverage amount</p>
            <p className="appSummaryInfoText"><CurrencyFormat number={props.coverageAmount} /></p>

            <p className="appSummaryInfoTitle">Product</p>
            <p className="appSummaryInfoText">{props.productName}</p>

            <p className="appSummaryInfoTitle">Premium</p>
            <p className="appSummaryInfoText"><CurrencyFormat number={props.premium} /></p>


            <div className="emailEdit">
              {props.email}
            </div>

            <Button color="primary" variant="contained" fullWidth className="mt-4" onClick={props.downloadPDF}><GetAppIcon className="downloadAppIcon" />Download application pdf</Button>
          </div>

          <div className="faq mt-4">
            <h3>FAQs</h3>

            <h4>Is it safe to pass my personal information over the internet?</h4>
            <p>
              Yes, this site is completely secure through 256-bit TLS encryption. All necessary precautions and technologies have been put in place to protect our customers and their personal information.
            </p>
          </div>

        </Col>
      </Row>
    </Container >
  )
}

function SendStatusEmailButton(props) {

  const [isClicked, setIsClicked] = useState(false);

  const onClick = () => {
    if (isClicked) {
      return;
    }
    setIsClicked(true);
    props.onResendEmailButtonClicked();
  }

  return (
    <span>
      {isClicked === false &&
        <a href="" onClick={e => { e.preventDefault(); onClick(); }} variant="outlined">Resend email status link</a>
      }
      {isClicked && <p className="stepText">Status email sent.</p>}
    </span>
  )
}
SendStatusEmailButton.propTypes = {
  onResendEmailButtonClicked: PropTypes.func.isRequired,
}

function StatusSection(props) {

  const activeColor = props.active ? '#333333' : '#999999';

  const useStyles = makeStyles(theme => ({
    statusSection: {
      borderColor: activeColor,
      color: activeColor,
    },
    time: {
      backgroundColor: activeColor,
    },
    circleNumber: {
      borderColor: activeColor,
    }
  }));

  const classes = useStyles();

  return (
    <div className={`${classes.statusSection} statusSection`}>
      <span className={`${classes.time} time`}>
        {(props.showTimeIcon !== false) && <UpdateIcon />} {props.time}
      </span>

      <div>
        <div className={`${classes.circleNumber} circleNumber`}>
          {props.stepNumber}
        </div>
        <div className="rightSection">
          <p className="stepTitle">{props.stepName}</p>

          {props.active && props.stepText && props.stepText.map((text, key) =>
            <div key={key} className="stepText">{text}</div>
          )}

        </div>
      </div>
    </div>
  )
}
StatusSection.propTypes = {
  active: PropTypes.bool.isRequired,
  stepNumber: PropTypes.string.isRequired,
  stepName: PropTypes.string.isRequired,
  stepText: PropTypes.array,
  showTimeIcon: PropTypes.bool,
}

ApplicationStatus.propTypes = {
  insuredName: PropTypes.string.isRequired,
  coverageAmount: PropTypes.number.isRequired,
  premium: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
}


const CaseStatus = {
  Life_Pending_AwaitingSignatures: 191,
  Life_Pending_PendingSubmission: 208,
  Life_Pending_AppSubmitted: 16,
  Life_Pending_Approved: 21,
  Life_Pending_ApprovedByCarrierFeed: 180,
  Life_Pending_ApprovedOther: 53,
  Life_Pending_IssuedDelReq: 80,
  Life_Pending_IssuedEDelReq: 523,
  Life_Pending_AwaitingPremiumDraft: 192,
  Life_Pending_PendingDecision: 101,
  Life_Pending_AwaitingAppSubmission: 211,
  Life_Pending_AwaitingThirdPartyApproval: 214,
  Life_Pending_PolicySentOut: 159,
  Life_Closed_Declined: 28,
  Life_Closed_NotTaken: 38,
  Life_Closed_Withdrawn: 94,
  Life_Closed_Cancelled: 187,
  Life_Closed_IncompleteClosed: 49,
  Life_Closed_Postponed: 84,
  Life_Paid_InForce: 70,
  Life_Paid_Reinstated: 11,
  Life_Paid_Surrendered: 1,
  Life_Paid_GracePeriod: 190,
  Life_Paid_Lapsed: 87,
  Life_Paid_Deceased: 25,
  Life_Other: 188,
  Health_Pending_AwaitingSignatures: 193,
  Health_Pending_PendingSubmission: 209,
  Health_Pending_AppSubmitted: 139,
  Health_Pending_Approved: 140,
  Health_Pending_AwaitingPremiumDraft: 194,
  Health_Pending_AwaitingAppSubmission: 212,
  Health_Pending_AwaitingThirdPartyApproval: 215,
  Health_Closed_Declined: 141,
  Health_Closed_NotTaken: 143,
  Health_Closed_Withdrawn: 149,
  Health_Closed_Cancelled: 195,
  Health_Closed_IncompleteClosed: 145,
  Health_Closed_Postponed: 196,
  Health_Paid_InForce: 148,
  Health_Paid_Reinstated: 199,
  Health_Paid_Surrendered: 200,
  Health_Paid_GracePeriod: 197,
  Health_Paid_Lapsed: 198,
  Disability_Pending_AwaitingSignatures: 203,
  Disability_Pending_PendingSubmission: 210,
  Disability_Pending_AppSubmitted: 124,
  Disability_Pending_AwaitingPremiumDraft: 202,
  Disability_Pending_Approved: 125,
  Disability_Pending_ApprovedOther: 131,
  Disability_Pending_AwaitingAppSubmission: 213,
  Disability_Pending_AwaitingThirdPartyApproval: 216,
  Disability_Closed_Declined: 126,
  Disability_Closed_NotTaken: 128,
  Disability_Closed_Withdrawn: 134,
  Disability_Closed_Cancelled: 204,
  Disability_Closed_IncompleteClosed: 138,
  Disability_Paid_InForce: 133,
  Disability_Paid_Surrendered: 206,
  Disability_Paid_GracePeriod: 207,
  Disability_Paid_Lapsed: 205,
};
Object.freeze(CaseStatus);

function ordinal(number) {
  switch (number) {
    case 1:
    case 21:
      return number + 'st';
    case 2:
    case 22:
      return number + 'nd';
    case 3:
    case 23:
      return number + 'rd';
    default:
      return number + 'th';
  }
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/ApplicationStatus.js